<template>
  <div class="container container-global">
    <h2>SIU au cuivre</h2>
    <div class="content">
      <p>
        Support en plastique radio opaque + bras avec fils de cuivre 375 à 380
        mm2
      </p>
      <br />
      <span>Mode d’action </span>
      <ul>
        <li>effet cytotoxique du cuivre sur les spermatozoïdes</li>
        <li>inflammation locale de l’endomètre empêchant la nidation</li>
      </ul>
      <span>Efficacité </span>
      <br />
      <br />
      <p>
        5 ans
        <br />
        <br />
        Possible contraception d’urgence dans les 5 jours suivant le rapport à
        risque
      </p>
      <br />
      <span>Contre-indications </span>
      <br />
      <br />
      <p>
        Grossesse, grossesse molaire,
        <br />
        infections en cours, maladie inflammatoire pelvienne en cours
        <br />
        cancer du col utérin et de l’endomètre,
        <br />
        malformations utérines et fibromes déformant la cavité,
        <br />
        hypersensibilité au cuivre,
        <br />
        4 premières semaines après l’accouchement,
        <br />
        possible en post abortum sauf si avortement septique
      </p>
      <br />
      <span>Effets indésirables : </span>
      <ul>
        <li>Règles plus abondantes et douloureuses</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
